declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export function trackPageView(path: string) {
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

export function trackCtaClick(cta: 'request_a_demo' | 'start_for_free', fromPath: string) {
  window.gtag?.('event', 'cta_click', {
    cta,
    from_path: fromPath,
  })
}
